import { render, staticRenderFns } from "./AppointmentOrderList.vue?vue&type=template&id=61338f5c&"
import script from "./AppointmentOrderList.vue?vue&type=script&lang=js&"
export * from "./AppointmentOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports